import { render } from "./StatButton.vue?vue&type=template&id=7e7bd6b9"
import script from "./StatButton.vue?vue&type=script&lang=js"
export * from "./StatButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__